import { Icon, Text } from '@mntn/ui-components'

interface Props {
  canCreateCampaign: boolean
  onCreateCampaign: () => Promise<void>
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const EmptyState: React.FC<Props> = ({ canCreateCampaign, onCreateCampaign }) => {
  return (
    <div className="border border-surface-bg pt-20 pb-20 gap-8 flex flex-col items-center text-center">
      <Icon name="FolderOpen" className="size-16 text-primary-accent" />
      {canCreateCampaign && (
        <Text variant="base" className="max-w-[456px] text-primary">
          No campaigns are assigned to this deal <br />
          <Text
            inline
            onClick={onCreateCampaign}
            className="underline cursor-pointer text-primary-accent bg-transparent"
          >
            create one now.
          </Text>
        </Text>
      )}
    </div>
  )
}
